
import { AudioManager } from "./../../AudioManager";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";

export class PauseMenu extends Phaser.GameObjects.Container {

    private musicLabel: Phaser.GameObjects.Text;
    private soundsLabel: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.y = -200;

        const menuBackgroundCenter = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "layout_box_3");
        menuBackgroundCenter.setOrigin(.5, 0);
        menuBackgroundCenter.scaleY = 6.1;
        this.add(menuBackgroundCenter);

        const menuBackgroundBottom = new Phaser.GameObjects.Image(this.scene, 0, menuBackgroundCenter.height * menuBackgroundCenter.scaleY, "texture_atlas_1", "layout_box_4");
        menuBackgroundBottom.setOrigin(.5, 0);
        this.add(menuBackgroundBottom);

        const blueBanner = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "title_area");
        blueBanner.setScale(.8);
        this.add(blueBanner);

        const menuTitle = new Phaser.GameObjects.Text(this.scene, 0, -10, "ADJUSTMENTS", {fontFamily: "Supercell", fontSize: "26px", color: "#FFFFFF"});
        menuTitle.setOrigin(.5);
        menuTitle.setStroke("#000000", 6);
        menuTitle.setShadow(4, 4, "#000000");
        this.add(menuTitle);

        const buttonContainer = new Phaser.GameObjects.Container(this.scene, 0, 100);
        this.add(buttonContainer);

        const restartButton = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_red_wide");
        restartButton.setInteractive();
        restartButton.on("pointerover", () => { 
            buttonContainer.setScale(1.025);   
        });
        restartButton.on("pointerout", () => { 
            buttonContainer.setScale(1);  
        });
        restartButton.on("pointerdown", this.onDownResetButton, this);
        buttonContainer.add(restartButton);

        const restartText = new Phaser.GameObjects.Text(this.scene, 0, 0, "Restart", {fontFamily: "Supercell", fontSize: "18px", color: "#FFFFFF"});
        restartText.setOrigin(.5);
        restartText.setStroke("#000000", 6);
        restartText.setShadow(3, 3, "#000000");
        buttonContainer.add(restartText);

        // EL FONDO PARA LOS BOTONES DE CONTROL DEL AUDIO
        const bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.setPosition(0, 255);
        bck.fillStyle(0xAAAAAA, .35);
        bck.fillRoundedRect(-165, -75, 330, 150, 10);
        this.add(bck);

        // lOS BOTONES DE AUDIO
        const musicButtonContainer = new Phaser.GameObjects.Container(this.scene, 0, 220);
        this.add(musicButtonContainer);

        const musicButton = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_info");
        musicButton.setInteractive();
        musicButton.on("pointerdown", this.onDownMusicButton, this);
        musicButton.on("pointerover", () => {

            if (this.alpha !== 1) {
                return;
            }

            musicButtonContainer.setScale(1.025); 
        }, this);
        musicButton.on("pointerout", () => { 
        
            if (this.alpha !== 1) {
                return;
            }

            musicButtonContainer.setScale(1); 
        }, this);
        musicButtonContainer.add(musicButton);

        const musicButtonText = new Phaser.GameObjects.Text(this.scene, -130, 0, "Music", {fontFamily: "Supercell", fontSize: "20px", color: "#FFFFFF"});
        musicButtonText.setOrigin(0, .5);
        musicButtonText.setStroke("#000000", 4);
        musicButtonText.setShadow(3, 3, "#000000");
        musicButtonContainer.add(musicButtonText);

        this.musicLabel = new Phaser.GameObjects.Text(this.scene, 92, 0, "OFF", {fontFamily: "Supercell", fontSize: "20px", color: "#FFFFFF"});
        this.musicLabel.setOrigin(.5);
        this.musicLabel.setStroke("#000000", 4);
        this.musicLabel.setShadow(3, 3, "#000000");
        musicButtonContainer.add(this.musicLabel);

        const soundsButtonContainer = new Phaser.GameObjects.Container(this.scene, 0, 290);
        this.add(soundsButtonContainer);

        const soundsButton = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_info");
        soundsButton.setInteractive();
        soundsButton.on("pointerdown", this.onDownSoundsButton, this);
        soundsButton.on("pointerover", () => {

            if (this.alpha !== 1) {
                return;
            }

            soundsButtonContainer.setScale(1.025); 
        }, this);
        musicButton.on("pointerout", () => { 
        
            if (this.alpha !== 1) {
                return;
            }

            soundsButtonContainer.setScale(1); 
        }, this);
        soundsButtonContainer.add(soundsButton);

        const soundsButtonText = new Phaser.GameObjects.Text(this.scene, -130, 0, "Sounds", {fontFamily: "Supercell", fontSize: "20px", color: "#FFFFFF"});
        soundsButtonText.setOrigin(0, .5);
        soundsButtonText.setStroke("#000000", 4);
        soundsButtonText.setShadow(3, 3, "#000000");
        soundsButtonContainer.add(soundsButtonText);

        this.soundsLabel = new Phaser.GameObjects.Text(this.scene, 92, 0, "OFF", {fontFamily: "Supercell", fontSize: "20px", color: "#FFFFFF"});
        this.soundsLabel.setOrigin(.5);
        this.soundsLabel.setStroke("#000000", 4);
        this.soundsLabel.setShadow(3, 3, "#000000");
        soundsButtonContainer.add(this.soundsLabel);

        this.setAudioLabels();

        this.setScale(.95);
        this.setAlpha(.7);

        this.scene.tweens.add({
            targets: this,
            scaleX: 1,
            scaleY: 1,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250
        });
    }

    private onDownResetButton(): void {

        GameManager.reset();   

        AudioManager.playSoundEffect("btn_click");
    }

    private onDownMusicButton(): void {

        AudioManager.toggleMusicState();

        this.setAudioLabels();

        AudioManager.playSoundEffect("btn_click");
    }

    private onDownSoundsButton(): void {

        AudioManager.toggleSoundState();

        this.setAudioLabels();

        AudioManager.playSoundEffect("btn_click");
    }

    private setAudioLabels(): void {

        if (GameVars.gameData.musicMuted) {
            this.musicLabel.text = "OFF";
            this.musicLabel.setColor("#FE0044");
        } else  {
            this.musicLabel.text = "ON";
            this.musicLabel.setColor("#32CB00");
        }

        if (GameVars.gameData.soundMuted) {
            this.soundsLabel.text = "OFF";
            this.soundsLabel.setColor("#FE0044");
        } else  {
            this.soundsLabel.text = "ON";
            this.soundsLabel.setColor("#32CB00");
        }
    }
}
